export const validateDayparts = (value) => {
    if (!value)
        return undefined;
    const hasAtLeastOneDaypartSelected = Object.values(value).some((hours) => hours.length < 24);
    if (!hasAtLeastOneDaypartSelected) {
        return "Cannot exclude all dayparts or include no dayparts.";
    }
    return undefined;
};
//# sourceMappingURL=dayparts.js.map